module.exports = __webpack_public_path__ + "assets/img/3-3-en.02995d64.png";